import React from 'react';
import './style.scss';
import Table from '../../Table';
import rank1 from '../../../assets/icons/rank-1.svg';
import rank2 from '../../../assets/icons/rank-2.svg';
import rank3 from '../../../assets/icons/rank-3.svg';
import germany from '../../../assets/images/germany-flag.png'
import portugal from '../../../assets/images/portugal-flag.png'
import france from '../../../assets/images/france-flag.png'

function LeaderboardTable() {

    const columns = [
        { Header: 'Rank', accessor: 'rank', Cell: ({ row }) => (
            <div className="rank-cell">
                {row.index < 3 ? <img src={row.index === 0 ? rank1 : row.index === 1 ? rank2 : rank3} alt={`Rank ${row.index + 1}`} /> : <span>{row.index + 1}</span>}
            </div>
        )},
        { Header: 'Username', accessor: 'username' },
        { Header: 'Profit', accessor: 'profit' },
        { Header: 'Account Size', accessor: 'accountSize' },
        { Header: 'Percent Gain', accessor: 'percentGain' },
        { Header: 'Country', accessor: 'country', Cell: ({ value }) => (
            <img src={value} alt={value} />
        )}
    ];

    const data = [
        {
            rank: 1,
            username: 'User1',
            profit: 1000,
            accountSize: '$10,000',
            percentGain: '10%',
            country: germany
        },
        {
            rank: 2,
            username: 'User2',
            profit: 800,
            accountSize: '$8,000',
            percentGain: '8%',
            country: portugal
        },
        {
            rank: 3,
            username: 'User3',
            profit: 600,
            accountSize: '$6,000',
            percentGain: '6%',
            country: france
        },
        {
            rank: 4,
            username: 'User4',
            profit: 400,
            accountSize: '$4,000',
            percentGain: '4%',
            country: germany
        },
        // Add more data objects as needed
    ];

    return (
        <div className='leaderboard-table'>
            <Table columns={columns} data={data} />
        </div>
    )
}

export default LeaderboardTable;
